export const navbarItems = [
    {
        key: 'services',
        label: (
            <a rel="noopener norererrer" href="/#services_sec" className="funbusi_dropdown_menu_item scroll">Services</a>
        )
    },
    {
        key: 'aboutUs',
        label: (
            <a rel="noopener norererrer" href="/#about_us" className="funbusi_dropdown_menu_item scroll">About Us</a>
        )
    },
    {
        key: 'contactUs',
        label: (
            <a rel="noopener norererrer" href="/#contact_us" className="funbusi_dropdown_menu_item scroll">Contact Us</a>
        )
    },
];

export const sloganList = [
    {
        id: 1,
        content: 'We are always ready for your call.'
    },
    {
        id: 2,
        content: 'We think what you think and do what you need.'
    },
    {
        id: 3,
        content: 'We make you have fun with your business.'
    }
];

export const servicesList = [
    {
        id: 1,
        title: <h3>Business<br />Solutions</h3>,
        description: 'We provide comprehensive business solutions for your business, including your POS system, alert and surveillance system'
    },
    {
        id: 2,
        title: <h3>POS<br />System</h3>,
        description: "Choose whom? No worries, we'll advice you the most suitable"
    },
    {
        id: 3,
        title: <h3>Web<br />Design</h3>,
        description: 'Our professional design will make your business remarkable'
    },
    {
        id: 4,
        title: <h3>High<br />Efficiency</h3>,
        description: 'Make your business easy'
    },
    {
        id: 5,
        title: <h3>Fast<br />Response</h3>,
        description: 'Time is money'
    },
    {
        id: 6,
        title: <h3>Good<br />Quality</h3>,
        description: 'No quality, no deal'
    }
]